import { render, staticRenderFns } from "./imbalance-table.vue?vue&type=template&id=56dd995a&scoped=true&"
import script from "./imbalance-table.vue?vue&type=script&lang=ts&"
export * from "./imbalance-table.vue?vue&type=script&lang=ts&"
import style0 from "./imbalance-table.vue?vue&type=style&index=0&id=56dd995a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd995a",
  null
  
)

export default component.exports